import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Turnos from "./pages/Turnos";
import "./styles/home.css";
import AdminTurnos from "./pages/AdminTurnos";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminLogin from "./components/auth/AdminLogin";
import AdminDashboard from "./components/dashboard/AdminDashboard";
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/turnos" element={<Turnos />} />
        
        <Route path="/admin" element={<AdminDashboard />} />   
      
      
<Route path="/admin/login" element={<AdminLogin />} />

{/* Protect dashboard */}
<Route
  path="/admin/dashboard"
  element={
    <ProtectedRoute>
      <AdminDashboard />
    </ProtectedRoute>
  }
/>

{/* Protect turnos */}
<Route
  path="/admin/turnos"
  element={
    <ProtectedRoute>
      <AdminTurnos />
    </ProtectedRoute>
  }
/>
      </Routes>
    </Router>
    
  );
}

export default App;
